import { Box, getPaletteColor } from 'pcln-design-system';
import React, { memo, useEffect } from 'react';
import styled from 'styled-components';
import Arrow from '../Arrow';
import useCalendar from '../useCalendar';
import useScroll from '../useScroll';
const Card = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CalendarCard__Card",
  componentId: "sc-bn1nkn-0"
})(["&&&{position:relative;height:100%;max-height:100vh;", "{", "}", ";}"], props => props.theme.mediaQueries[1], props => !props.isMobile && `
        box-shadow: ${props.hasBoxShadow ? props.theme.shadows['overlay-lg'] : 'none'};
        height: auto;
      `, props => !props.isMobile ? `background-color: ${getPaletteColor('background.lightest')(props)}` : '');
const ScrollContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CalendarCard__ScrollContainer",
  componentId: "sc-bn1nkn-1"
})(["&&&{height:100%;overflow-y:scroll;& > div{height:100%;max-height:100vh;", "{", "}}}"], props => props.theme.mediaQueries[1], props => !props.isMobile && `
            overflow: auto;
        `);
const MonthWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CalendarCard__MonthWrapper",
  componentId: "sc-bn1nkn-2"
})([""]);
/** @public */
function CalendarCard({
  arrows = true,
  boxShadow = true,
  calendarWrapperStyles = {},
  children,
  isMobile,
  monthsToShow: monthsToShowProp = 2,
  monthWidth = 350,
  roundedCorners,
  scrollToMonth = 0,
  useDefaultFooter,
  keyNavHandler,
  setCalendarRef
}) {
  const monthsToShow = isMobile ? 12 : monthsToShowProp;
  const {
    use2024DesignSeti,
    handleKeyDismiss
  } = useCalendar();
  const {
    disableLeftArrow,
    monthIndex,
    scrollBoxDOMNode,
    scrollContainerDOMNode,
    disableRightArrow,
    onArrowFocus,
    onScroll,
    scrollLeft,
    scrollRight
  } = useScroll();
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDismiss);
    return () => {
      document.removeEventListener('keydown', handleKeyDismiss);
    };
  }, []);
  useEffect(() => {
    const monthNode = scrollBoxDOMNode?.current?.children[0]?.children?.[scrollToMonth];
    if (monthNode && scrollContainerDOMNode?.current) {
      scrollContainerDOMNode.current.scrollLeft = monthNode?.offsetLeft ?? 0;
      scrollContainerDOMNode.current.scrollTop = monthNode?.offsetTop ?? 0;
    }
  }, []);
  const childrenLength = React.Children.count(children) || 1;
  return React.createElement(Box, {
    height: '100%',
    ref: setCalendarRef
  }, React.createElement(Card, {
    borderRadius: roundedCorners ? '2xl' : undefined,
    hasBoxShadow: boxShadow,
    isMobile: isMobile,
    rounded: useDefaultFooter ? 'top' : undefined,
    roundedCorners: roundedCorners,
    width: isMobile ? 1 : [1, 1, monthsToShow * monthWidth]
  }, React.createElement(ScrollContainer, {
    borderRadius: roundedCorners ? '2xl' : undefined,
    "data-testid": 'scroll-wrapper',
    isMobile: isMobile,
    ref: isMobile ? scrollContainerDOMNode : null,
    onScroll: onScroll
  }, React.createElement("div", {
    ref: !isMobile ? scrollContainerDOMNode : null,
    onScroll: onScroll
  }, React.createElement("div", {
    ref: scrollBoxDOMNode
  }, React.createElement(MonthWrapper, {
    ...calendarWrapperStyles,
    width: isMobile ? 1 : [1, null, monthWidth * childrenLength],
    overflowY: 'scroll',
    onKeyDown: keyNavHandler,
    "data-testid": 'scroll-container'
  }, children)))), arrows && React.createElement(React.Fragment, null, React.createElement(Arrow, {
    isDisabled: disableLeftArrow,
    isMobile: isMobile,
    isPrev: true,
    monthCount: monthIndex,
    use2024DesignSeti: use2024DesignSeti,
    onClick: scrollLeft
  }), React.createElement(Arrow, {
    isDisabled: disableRightArrow,
    isMobile: isMobile,
    monthCount: monthIndex,
    monthsToShow: monthsToShow,
    use2024DesignSeti: use2024DesignSeti,
    onClick: scrollRight,
    onFocus: onArrowFocus
  }))));
}
export default memo(CalendarCard);